module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/pink.png?5db00a17";